import React from "react";
import OBHeaderLogo from "../../../assets/ob_header_logo.png";
import { ProgressBar } from "react-bootstrap";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
function OBHeader() {
  const { data: userProfile } = useGetUserProfileQuery();
  return (
    <section className="ob-header bg-white d-flex flex-wrap  w-100 align-item-center justify-content-md-between justify-content-center gap-md-0 gap-2">
      {/* logo */}
      <div className="ob-header-logo-div">
        <img src={OBHeaderLogo} alt="logo" width={146} height={34} />
      </div>
      {/* progress bar */}
      <div className="d-flex w-max h-100 pe-4 align-items-center justify-content-center gap-3 mb-md-0 mb-3">
        <ProgressBar
          now={userProfile?.data?.supplier?.on_boardings * 20 || 0}
          className={"ob-header-progress-bar "}
        />
        <p className="ob-header-progress-bar-text p-0 m-0">{`${
          userProfile?.data?.supplier?.on_boardings
            ? userProfile?.data?.supplier?.on_boardings * 20
            : 0
        }% Complete`}</p>
      </div>
    </section>
  );
}

export default OBHeader;
